export default __webpack_public_path__ + "static/media/s5.b4d21157.jpeg";